import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Bound } from "lib/@components/binding/Bound"
import { getScopedDemands } from "lib/authorization/controller/scoped-demands.api"

const dummyResult = Object.freeze([])

export function ScopedDemands({ scope, id, payload, children }) {
    const { scopedDemands } = useBoundContext()
    const demands = getScopedDemands.useResults(scope, id, payload) ?? dummyResult
    const mergedDemands = scopedDemands ? [...scopedDemands, ...demands] : demands

    console.groupCollapsed(`[ScopedDemands] scope=${scope} id=${id}`)
    console.log("payload:", payload)
    console.log("scopedDemands (from context):", scopedDemands)
    console.log("demands (from api):", demands)
    console.log("mergedDemands:", mergedDemands)
    console.log("unique mergedDemands:", mergedDemands?.unique?.())
    console.groupEnd()

    return <Bound scopedDemands={mergedDemands?.unique()}>{children}</Bound>
}
